import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component
export default class SkeletonList extends Vue {
  @Prop({ default: '#ECEBEB' }) color!: String
  @Prop({ default: 3 }) number!: Number
}
